import React from 'react';
import './GuestReviews.css';
import { useLanguage } from '../contexts/LanguageContext';
import SeparatorLine from '../assets/photos/sep3.png';

const GOOGLE_REVIEWS_URL =
  'https://www.google.com/maps/search/?api=1&query=' +
  encodeURIComponent('מלון בוטיק המקום נטועה');

const Stars = ({ count }) => (
  <span className="guest-review-stars" aria-label={`${count}/5`}>
    {'★'.repeat(count)}
  </span>
);

const GuestReviews = () => {
  const { t } = useLanguage();
  const items = t('guestReviews.items');

  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <div className="guest-reviews">
      <img src={SeparatorLine} className="separator" alt="" />
      <h3>{t('guestReviews.title')}</h3>
      <div className="guest-reviews-rating">
        <span className="guest-reviews-score">4.7</span>
        <Stars count={5} />
        <span className="guest-reviews-count">{t('guestReviews.ratingCount')}</span>
      </div>
      <div className="guest-reviews-grid">
        {items.map((item) => (
          <figure className="guest-review-card" key={item.text.slice(0, 24)}>
            {item.stars && <Stars count={item.stars} />}
            <blockquote>{item.text}</blockquote>
            <figcaption>
              <span className="guest-review-source">{t('guestReviews.source')}</span>
            </figcaption>
          </figure>
        ))}
      </div>
      <a
        className="guest-reviews-cta"
        href={GOOGLE_REVIEWS_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('guestReviews.cta')}
      </a>
    </div>
  );
};

export default GuestReviews;
